$(document).ready(function () {
  var $slider = $(".product-image-slider").flickity({
    wrapAround: true,
    initialIndex: 1,
    prevNextButtons: false,
    pageDots: true,
    autoPlay: false
  });

  // Handle window resize event
  $(window).resize(function () {
    $slider.flickity('resize');
  });
});

